<template>
	<frontend-layout>
		<Head>
			<title>{{ $t("document") }} - {{ $t("siteTitle") }}</title>
		</Head>
		<template #header>
			<h1 class="page-title p-0">{{ $t("document") }}</h1>
		</template>

		<template #breadcrumb>
			<div class="pageInfo mb-2 p-1">
				<div class="page-breadcrumb float-sm-right">
					<ol class="breadcrumb">
						<li class="breadcrumb-item">
							<InertiaLink
								:href="'/'"
								:class="{
									active: $page.url === '/',
								}">
								{{ $t("home") }}
							</InertiaLink>
						</li>
						<li class="breadcrumb-item">
							{{ $t("document") }}
						</li>
					</ol>
				</div>
			</div>
		</template>

		<section>
			<div class="ts-container is-narrow">
				<div class="announcement">
					<div class="row">&nbsp;</div>
				</div>
				<template v-if="docs.length > 0">
					<div v-for="primary in docs" :key="primary.title">
						<div class="section-title">
							<h1 v-if="$i18n.locale == 'zh-TW'">
								{{ primary.title }}
							</h1>
							<h1 v-else>{{ primary.title_en }}</h1>
							<div
								v-if="$i18n.locale == 'zh-TW'"
								v-html="primary.introduction"></div>
							<div v-else v-html="primary.introduction_en"></div>
							<p></p>
						</div>

						<div
							v-if="$i18n.locale == 'zh-TW'"
							class="tab-container">
							<faqBlock
								v-for="secondary in primary.AllPublicSecondaryCategories"
								:key="secondary.title"
								:title="secondary.title"
								:introduction="secondary.introduction"
								:docs="secondary.AllPublicDocuments"></faqBlock>
						</div>
						<div v-else class="tab-container">
							<faqBlock
								v-for="secondary in primary.AllPublicSecondaryCategories"
								:key="secondary.title_en"
								:title="secondary.title_en"
								:introduction="secondary.introduction_en"
								:docs="secondary.AllPublicDocuments"></faqBlock>
						</div>
					</div>
				</template>
				<template v-else>
					<div v-if="!loading" class="none_docs">
						<h2>{{ $t("docs.noDoc") }}</h2>
						<InertiaLink class="btn btn-primary mt-3" href="/">
							{{ $t("docs.backHome") }}
						</InertiaLink>
					</div>
				</template>
			</div>
		</section>
	</frontend-layout>
</template>

<script>
import FrontendLayout from "@/Frontend/Shared/Layout";
import faqBlock from "@/Frontend/Components/faqBlock";
import JQuery from "jquery";

export default {
	// Using the shorthand

	components: {},
	data() {
		return {
			csrf: document
				.querySelector('meta[name="csrf-token"]')
				.getAttribute("content"),
			docs: [],
			loading: true,
		};
	},
	methods: {
		getAllDocs: function () {
			axios.get("/allDocs").then(
				function (response) {
					this.docs = response.data;
					this.loading = false;
				}.bind(this)
			);
		},
	},
	created: function () {
		this.getAllDocs();
	},
	mounted: function () {
		JQuery(document).ready(function () {
			JQuery(".titleWrapper").click(function () {
				var toggle = JQuery(this).next("div#descwrapper");
				JQuery(toggle).slideToggle("slow");
			});
			JQuery(".inactive").click(function () {
				JQuery(this).toggleClass("inactive active");
			});
		});
	},
	components: {
		faqBlock,
		FrontendLayout,
	},
};
</script>

<style scoped>
.none_docs {
	text-align: center;
	vertical-align: middle;
}
.announcement {
	text-align: center;
}

.section-title {
	padding: 10px 0px;
	background-color: #ffe7eb00;
	padding-bottom: 0px;
	margin-bottom: 0px;
}
.section-title h1 {
	margin: 0;
	font-family: "Poppins", sans-serif;
	font-weight: 700;
	font-size: 1.63rem;
	line-height: 26px;
	color: #0a7a7f;
}
.section-title p {
	margin-bottom: 0px;
	color: #e5546e;
}
.tab-container {
	padding: 20px 0px;
}

h3 {
	font-family: Poppins, Tahoma, sans-serif;
	font-size: 1rem;
	font-weight: 700;
	line-height: 20px;
	color: #4d4e58;
	margin: 0;
}
</style>
